import React from "react";
import { toast } from "react-toastify";
import ConfirmToast from "../../notification/Confirm";

export function useModuleRestart(
  restartModule?: (identifier: string) => Promise<any>,
  refreshData?: () => void,
) {
  const restart = (module_identifier: string) => {
    const toastId = `restart-module-${module_identifier}`;

    toast(
      <ConfirmToast
        message="Перезагрузить модуль?"
        onConfirm={async () => {
          try {
            if (!restartModule) {
              toast.update(toastId, {
                render: "Функция restartModule не передана",
                type: "error",
                autoClose: 5000,
                closeButton: true,
                closeOnClick: true,
                draggable: true,
                progressClassName: undefined,
              });
              return;
            }

            const result = await restartModule(module_identifier);

            if (result?.status === "accepted") {
              toast.update(toastId, {
                render: "Команда принята",
                type: "success",
                autoClose: 5000,
                closeButton: true,
                closeOnClick: true,
                draggable: true,
                progressClassName: undefined,
              });
              if (refreshData) refreshData();
            } else if (result?.status === "rejected") {
              // `АУД-Н158`: отказ изделия называет причину — `error`, иначе
              // `info` (кадр `Response {status:"rejected", info:"update in
              // progress"}`). Без причины остаётся прежний текст: «отклонена» —
              // уже ответ, пустая причина читалась бы как сбой показа.
              const reason = result.error || result.info;

              toast.update(toastId, {
                render: reason
                  ? `Команда отклонена: ${reason}`
                  : "Команда отклонена",
                type: "error",
                autoClose: 5000,
                closeButton: true,
                closeOnClick: true,
                draggable: true,
                progressClassName: undefined,
              });
            } else {
              toast.update(toastId, {
                render: "Модуль перезагружен",
                type: "info",
                autoClose: 5000,
                closeButton: true,
                closeOnClick: true,
                draggable: true,
                progressClassName: undefined,
              });
            }
          } catch (error: any) {
            let errorMessage = "Ошибка при перезагрузке модуля";
            if (error?.response?.data?.error) {
              errorMessage = error.response.data.error;
            } else if (error?.message) {
              errorMessage = error.message;
            }

            toast.update(toastId, {
              render: errorMessage,
              type: "error",
              autoClose: 5000,
              closeButton: true,
              closeOnClick: true,
              draggable: true,
              progressClassName: undefined,
            });
          }
        }}
        title="Перезагрузить"
        toastId={toastId}
        closeOnConfirm={false}
      />,
      {
        toastId,
        style: { borderRadius: 0 },
        progressClassName: "toast-progress-delete",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      },
    );
  };

  return { restart };
}
